import { gql } from 'graphql-request';

export const DELETE_SEARCH_FILTER_QUERY = gql`
  mutation DeleteSearchFilter($uuid: ID!) {
    deleteSearchFilter(input: { uuid: $uuid }) {
      status
    }
  }
`;
